import { Component, OnInit } from '@angular/core';
import { CtaService } from "../../_services/cta.service";
declare var hbspt: any // pega esto arriba del componente

@Component({
  selector: 'bxl-live-streaming',
  templateUrl: 'live-streaming.component.html',
})
export class LiveStreamingComponent implements OnInit {
  initialized = false;
  constructor(public ctaService:CtaService) { }

  ngAfterContentInit() {
    hbspt.forms.create({
      region: "na1",
      portalId: "21144641",
      formId: "17e74dcb-2609-478e-848a-ceffdd2c4df2",
      target: "#hubspotForm"
    });
  }
  ngOnInit(): void {
    this.initialized = true;
  }
}
